<router-outlet></router-outlet>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<app-http-spinner></app-http-spinner>
<!-- <ng-http-loader
  [entryComponent]="spinnerComponent"
  [opacity]="0.95"
  [minDuration]="250"
></ng-http-loader> -->
